import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
	selector: 'bb-password-input',
	templateUrl: './bb-password-input.component.html',
	styleUrls: ['./bb-password-input.component.scss'],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => BbPasswordInputComponent),
		multi: true
	}]

})

export class BbPasswordInputComponent implements ControlValueAccessor {
	pw: string;
	show = false;

	constructor() {}


	propagate() {
		this.propagateChange(this.pw);
	}

	// ControlValueAccessor functions:

	writeValue(value: any) {
		this.pw = value;
	}

	registerOnChange(fn: any) {
		this.propagateChange = fn;
	}

	registerOnTouched() {

	}

	propagateChange(_: any) {}
}
